/* eslint-disable no-param-reassign */
import {
  IRaffleAffiliateStatusBadgeDTO,
  IRaffleAffiliateStatusSelectOptionsDTO,
} from "@hooks/dtos/raffles/IRaffleAffiliateDTO";
import { IRaffleDefaultStatusDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { IRaffleDefaultTicketStatusBadgeDTO } from "@hooks/dtos/raffles/IRaffleDefaultTicketDTO";
import {
  IRaffleDefaultTicketPurchaseSelectOptionsDTO,
  IRaffleDefaultTicketPurchaseStatusBadgeDTO,
} from "@hooks/dtos/raffles/IRaffleDefaultTicketPurchaseDTO";
import {
  IRaffleSelectOptionsDTO,
  RaffleStatusTypes,
} from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { RaffleStatusEnum } from "@hooks/enums/raffle";
import {
  RaffleAffiliateStatusEnum,
  RaffleAffiliateStatusTypes,
} from "@hooks/enums/raffle_affiliate";
import {
  RaffleDefaultTicketStatusEnum,
  RaffleDefaultTicketStatusTypes,
} from "@hooks/enums/raffle_default_ticket";
import {
  RaffleDefaultTicketPurchaseStatusTypes,
  RaffleDefaultTicketPurchaseStatusEnum,
} from "@hooks/enums/raffle_default_ticket_purchase";

export const raffleStatusTypes: IRaffleDefaultStatusDTO[] = [
  {
    status: RaffleStatusEnum.ACTIVE,
    text: "Ativa",
    title: "Esta campanha está ativa.",
    color: "success",
  },
  {
    status: RaffleStatusEnum.INACTIVE,
    text: "Inativa",
    title: "Esta Campanha está inativa.",
    color: "danger",
  },
  {
    status: RaffleStatusEnum.CREATING,
    text: "Criando",
    title: "Esta Campanha está sendo criada.",
    color: "info",
  },
  {
    status: RaffleStatusEnum.PENDING,
    text: "Pendente",
    title: "Esta Campanha está com pendência de pagamento.",
    color: "warning",
  },
  {
    status: RaffleStatusEnum.FINISHED,
    text: "Finalizada",
    title: "Esta Campanha finalizou.",
    color: "primary",
  },
  {
    status: RaffleStatusEnum.EXCLUDED,
    text: "Excluída",
    title: "Esta Campanha foi excluída.",
    color: "danger",
  },
  {
    status: RaffleStatusEnum.QUEUE,
    text: "Fila",
    title: "Esta Campanha está na fila.",
    color: "info",
  },
  {
    status: RaffleStatusEnum.WAITING,
    text: "Aguardando",
    title: "Esta Campanha está aguardando.",
    color: "info",
  },
];

export const getRaffleStatus = (
  status: RaffleStatusTypes,
): IRaffleDefaultStatusDTO => {
  let ret = raffleStatusTypes.find(
    (eventStatusType) => eventStatusType.status === status,
  );
  if (!ret)
    ret = { status: "x", text: "Error", title: "Error", color: "danger" };
  return ret;
};

export const raffleStatusSelect: IRaffleSelectOptionsDTO[] = [
  {
    status: RaffleStatusEnum.ACTIVE,
    text: "Ativa",
    description: "Campanha ativa.",
  },
  {
    status: RaffleStatusEnum.INACTIVE,
    text: "Inativa",
    description: "Campanha inativa.",
  },
  {
    status: RaffleStatusEnum.CREATING,
    text: "Criando",
    description: "Campanha sendo criada.",
  },
  {
    status: RaffleStatusEnum.PENDING,
    text: "Pendente",
    description: "Campanha com pendência de pagamento.",
  },
  {
    status: RaffleStatusEnum.FINISHED,
    text: "Finalizada",
    description: "Esta Campanha finalizou.",
  },
  {
    status: RaffleStatusEnum.EXCLUDED,
    text: "Excluída",
    description: "Campanha excluída.",
  },
  {
    status: RaffleStatusEnum.QUEUE,
    text: "Fila",
    description: "Campanha na fila.",
  },
  {
    status: RaffleStatusEnum.WAITING,
    text: "Aguardando",
    description: "Campanha aguardando.",
  },
];

const raffleDefaultTicketPurchaseStatusBadges: IRaffleDefaultTicketPurchaseStatusBadgeDTO[] =
  [
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.PAID,
      title: "Pago",
      text: "Ticket pago com sucesso",
      color: "success",
    },
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.REFUND,
      title: "Reembolsado",
      text: "Este ticket foi reembolsado",
      color: "warning",
    },
  ];

export const getRaffleDefaultTicketPurchaseStatus = (
  status: RaffleDefaultTicketPurchaseStatusTypes,
): IRaffleDefaultTicketPurchaseStatusBadgeDTO => {
  let ret = raffleDefaultTicketPurchaseStatusBadges.find(
    (raffleDefaultTicketPurchaseStatusBadges) =>
      raffleDefaultTicketPurchaseStatusBadges.status === status,
  );
  if (!ret)
    ret = { status: "", text: "Error", title: "Error", color: "danger" };
  return ret;
};

export const raffleDefaultTicketPurchaseStatusSelect: IRaffleDefaultTicketPurchaseSelectOptionsDTO[] =
  [
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.PAID,
      text: "Pago",
      description: "Para tickets pagos.",
    },
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.REFUND,
      text: "Reembolsado",
      description: "Para tickets reembolsados.",
    },
  ];

export const raffleAffiliateStatusSelect: IRaffleAffiliateStatusSelectOptionsDTO[] =
  [
    {
      status: RaffleAffiliateStatusEnum.ACTIVE,
      text: "Ativo",
      description: "Afiliado ativo e recebendo comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.INACTIVE,
      text: "Inativo",
      description: "Afiliado inativo, não recebe comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.DELETED,
      text: "Excluído",
      description: "Afiliado excluído do sistema",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_BLOCK,
      text: "Bloqueado",
      description:
        "Afiliado bloqueado, não receberá mais solicitações deste parceiro",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_REQUEST,
      text: "Solicitado pelo Dono",
      description: "Solicitação de afiliação feita pelo dono da rifa",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_REJECTED,
      text: "Rejeitado pelo Dono",
      description: "Solicitação de afiliação rejeitada pelo dono da rifa",
    },

    // --- Customer Actions --- //
    {
      status: RaffleAffiliateStatusEnum.CUSTOMER_BLOCK,
      text: "Bloqueada",
      description:
        "Campanha bloqueada, não receberá mais solicitações da mesma.",
    },
    {
      status: RaffleAffiliateStatusEnum.CUSTOMER_REQUEST,
      text: "Solicitado pelo Parceiro",
      description: "Solicitação de afiliação feita pelo parceiro",
    },
    {
      status: RaffleAffiliateStatusEnum.CUSTOMER_REJECTED,
      text: "Rejeitado pelo Parceiro",
      description: "Solicitação de afiliação rejeitada pelo parceiro",
    },
  ];

export const raffleAffiliateStatusOwnerSelect: IRaffleAffiliateStatusSelectOptionsDTO[] =
  [
    {
      status: RaffleAffiliateStatusEnum.ACTIVE,
      text: "Ativo",
      description: "Afiliado ativo e recebendo comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.INACTIVE,
      text: "Inativo",
      description: "Afiliado inativo, não recebe comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.DELETED,
      text: "Excluído",
      description: "Afiliado excluído da campanha",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_BLOCK,
      text: "Bloqueado",
      description:
        "Parceiro bloqueado, não recebe mais solicitações deste parceiro",
    },
  ];

const raffleAffiliateStatusBadges: IRaffleAffiliateStatusBadgeDTO[] = [
  // Active status
  {
    status: RaffleAffiliateStatusEnum.ACTIVE,
    title: "Ativo",
    text: "Afiliado ativo e recebendo comissões",
    color: "success",
  },

  // Inactive status
  {
    status: RaffleAffiliateStatusEnum.INACTIVE,
    title: "Inativo",
    text: "Afiliado inativo, não recebe comissões",
    color: "danger",
  },

  // Request status
  {
    status: RaffleAffiliateStatusEnum.CUSTOMER_REQUEST,
    title: "Solicitação do Parceiro",
    text: "Parceiro solicitou afiliação",
    color: "warning",
  },
  {
    status: RaffleAffiliateStatusEnum.OWNER_REQUEST,
    title: "Solicitação do Proprietário",
    text: "Dono(a) da Campanha solicitou afiliação",
    color: "info",
  },

  // Rejection status
  {
    status: RaffleAffiliateStatusEnum.CUSTOMER_REJECTED,
    title: "Rejeitado pelo Parceiro",
    text: "Parceiro rejeitou a afiliação",
    color: "danger",
  },
  {
    status: RaffleAffiliateStatusEnum.OWNER_REJECTED,
    title: "Rejeitado pelo Dono",
    text: "Dono da rifa rejeitou a afiliação",
    color: "danger",
  },

  // Blocked status
  {
    status: RaffleAffiliateStatusEnum.OWNER_BLOCK,
    title: "Bloqueado",
    text: "Parceiro bloqueado pelo proprietário",
    color: "danger",
  },
  {
    status: RaffleAffiliateStatusEnum.CUSTOMER_BLOCK,
    title: "🔒 Bloqueada",
    text: "Parceiro bloqueou esta Campanha",
    color: "danger",
  },

  // Deleted status
  {
    status: RaffleAffiliateStatusEnum.DELETED,
    title: "Excluído",
    text: "Afiliado removido do sistema",
    color: "dark",
  },
];

export const getRaffleAffiliateStatus = (
  status: RaffleAffiliateStatusTypes,
): IRaffleAffiliateStatusBadgeDTO => {
  let ret = raffleAffiliateStatusBadges.find(
    (raffleAffiliateStatusBadges) =>
      raffleAffiliateStatusBadges.status === status,
  );
  if (!ret)
    ret = { status: "", text: "Error", title: "Error", color: "danger" };
  return ret;
};

export const raffleDefaultTicketStatusTypes: IRaffleDefaultTicketStatusBadgeDTO[] =
  [
    {
      status: RaffleDefaultTicketStatusEnum.AVAILABLE,
      text: "Disponível",
      title: "Este ticket está disponível.",
      color: "success",
    },
    {
      status: RaffleDefaultTicketStatusEnum.UNAVAILABLE,
      text: "Indisponível",
      title: "Este ticket não está disponível.",
      color: "warning",
    },
    {
      status: RaffleDefaultTicketStatusEnum.PENDING,
      text: "Pendente",
      title:
        "Este ticket está reservado para pagamento, geralmente por alguns minutos para liberar ou ser confirmado.",
      color: "primary",
    },
  ];

export const getRaffleDefaultTicketStatus = (
  status: RaffleDefaultTicketStatusTypes,
): IRaffleDefaultTicketStatusBadgeDTO => {
  let ret = raffleDefaultTicketStatusTypes.find((it) => it.status === status);
  if (!ret)
    ret = { status: "", text: "Error", title: "Error", color: "danger" };
  return ret;
};

export const raffleDefaultCustomerTicketStatusTypes: IRaffleDefaultTicketStatusBadgeDTO[] =
  [
    {
      status: RaffleDefaultTicketStatusEnum.AVAILABLE,
      text: "Disponível",
      title: "Este ticket está disponível.",
      color: "success",
    },
    {
      status: RaffleDefaultTicketStatusEnum.UNAVAILABLE,
      text: "Adquirido",
      title: "Este ticket foi adquirido por você.",
      color: "success",
    },
    {
      status: RaffleDefaultTicketStatusEnum.PENDING,
      text: "Pendente",
      title: "Este ticket está aguardando confirmação de pagamento.",
      color: "primary",
    },
  ];

export const getRaffleDefaultCustomerTicketStatus = (
  status: RaffleDefaultTicketStatusTypes,
): IRaffleDefaultTicketStatusBadgeDTO => {
  let ret = raffleDefaultCustomerTicketStatusTypes.find(
    (it) => it.status === status,
  );
  if (!ret)
    ret = { status: "", text: "Error", title: "Error", color: "danger" };
  return ret;
};
